import { put } from "redux-saga/effects";
import { LogsReportAction } from "../../action";
import { Client } from "../../../../utils/transport";
import { SOMETHING_WENT_WRONG } from "constants/staticText";
import { ExportCSV } from "utils/export-csv";
import dayjs from "dayjs";
import { hmsOnlyNumber } from "utils/timeConverter";
import { getDownloadTableViewColumns } from "utils/commonUtils";

const ExportData = (
  fileName,
  data,
  colunms,
  filterDate,
  teams,
  reportType,
  payload
) => {
  let result = [];
  const Generated = "Generated Date:-" + dayjs().format("DD-MM-YYYY hh:mm a");
  const generatedData = [
    fileName,
    teams.length > 0
      ? "Teams: - " + teams.join(",").replaceAll(",", "/")
      : "Teams: - " + "All Teams",
    "Date:-" + filterDate,

    Generated,
    colunms.join(),
  ];

  data.forEach((record) => {
    const user = payload.user_map_data?.[record.identity_id];
    const employeeName =
      !record?.first_name && !record?.last_name
        ? "--"
        : `${record.first_name} ${record.last_name}`;

    const dynamicValues = getDownloadTableViewColumns(
      payload.viewFields,
      user,
      payload.team_map_data
    );

    const fixedValues = [
      record?.application_name,
      record?.url,
      record?.title.replaceAll(",", " "),
      ...(reportType === "raw"
        ? [
            dayjs(record?.start_time).format("YYYY-MM-DD hh:mm A"),
            dayjs(record?.start_time).format("YYYY-MM-DD hh:mm A"),
          ]
        : reportType === "datewise"
        ? [record?.event_day]
        : []),
      hmsOnlyNumber(record?.duration),
      record?.app_policy_status,
      hmsOnlyNumber(record?.active_time),
      hmsOnlyNumber(record?.idle_time),
      record?.keystroke_count,
      record?.mouse_clicks,
      record?.system_status,
    ];
    generatedData.push(
      [employeeName, ...dynamicValues, ...fixedValues].join(",")
    );
  });
  result = generatedData;
  return result;
};
const getDownloadCSV = (action, data) => {
  const teamIds = action.payload.body.group_id.split(",");
  const selectTeamNames = action.payload.team_list_data
    .filter((item) => teamIds.includes(item.id))
    .map((item) => item.name);

  const date =
    dayjs(action?.payload.body.start_date).format("YYYY-MM-DD") +
    " To " +
    dayjs(action?.payload.body.end_date).format("YYYY-MM-DD");
  // Dynamic columns
  const dynamicFields = action.payload.viewFields || [];
  const dynamicHeaders = dynamicFields.map((field) => field.label);

  // Fixed headers
  const fixedHeaders = [
    "Application",
    "URL",
    "Title",
    ...(action.payload.body.report_type === "raw"
      ? ["Start time", "End time"]
      : action.payload.body.report_type === "datewise"
      ? ["Date"]
      : []),
    "Duration",
    "Mapping status",
    "Active time",
    "Idle time",
    "Key presses",
    "Mouse clicks",
    "System status",
  ];

  const finalHeaders = [
    "Employee", // full name
    ...dynamicHeaders,
    ...fixedHeaders,
  ];

  const exdata = ExportData(
    "Logs Report List",
    data,
    finalHeaders,
    date,
    selectTeamNames,
    action.payload.body.report_type,
    action.payload
  );

  ExportCSV(
    action.payload.body.report_type === "raw"
      ? "Individual Log_report_List_"
      : (action.payload.body.report_type + " Logs_report_List_").replace(
          /^./,
          (str) => str.toUpperCase()
        ),
    exdata
  );
};
export function* fetchLogsReportSaga(action) {
  const config = {
    method: "POST",
    url: `query/reports/app_log_report`,
    headers: {
      ...action.payload.headers,
    },
    data: { ...action.payload.body },
  };

  try {
    const response = yield Client.request(config);
    yield put(LogsReportAction.fetchLogsReportSuccess(response.data));
  } catch (err) {
    let errorMessage = SOMETHING_WENT_WRONG;
    if (err.response?.status < 500) {
      errorMessage = err.response?.data?.errors?.[0]?.detail;
    }
    yield put(LogsReportAction.fetchLogsReportFailed(errorMessage));
  }
}

export function* downloadLogsReportSaga(action) {
  const config = {
    method: "POST",
    url: `query/reports/app_log_report`,
    headers: {
      ...action.payload.headers,
    },
    data: { ...action.payload.body },
  };

  try {
    const response = yield Client.request(config);
    const rows = response.data.data;
    const n = Math.floor(response.data.optional / action.payload.body.limit);

    for (let i = 0; i < n; i++) {
      const config = {
        method: "POST",
        url: `query/reports/app_log_report`,
        headers: {
          ...action.payload.headers,
        },
        data: { ...action.payload.body, page: i + 2 },
      };
      const response = yield Client.request(config);
      rows.push(...response.data.data);
    }
    getDownloadCSV(action, rows);
    yield put(LogsReportAction.downloadLogsReportSuccess(response.data));
  } catch (err) {
    console.log(err);
    let errorMessage = SOMETHING_WENT_WRONG;
    if (err.response?.status < 500) {
      errorMessage = err.response?.data?.errors?.[0]?.detail;
    }
    yield put(LogsReportAction.downloadLogsReportFailed(errorMessage));
  }
}
